import React, { createContext, useContext } from "react";
import { UseFormReturn } from "react-hook-form";
import { IUserProfileData } from "../../../../types/forms";
import { AppDispatch } from "../../../../store";

interface Props {
    formMethods: UseFormReturn<IUserProfileData, any, undefined>;
    dispatch: AppDispatch;
}

const ProfilePageContext = createContext<Props | null>(null);

export const useProfilePageContext = () => {
    const context = useContext(ProfilePageContext);
    if (!context) {
        throw new Error(
            "useProfilePageContext must be used within a ProfilePageProvider",
        );
    }
    return context;
};

export const ProfilePageProvider: React.FC<{
    children: React.ReactNode;
    props: Props;
}> = ({ children, props }) => {
    return (
        <ProfilePageContext.Provider value={props}>
            {children}
        </ProfilePageContext.Provider>
    );
};
